import BaseService from "./base.service";

export default class ConfigService extends BaseService {
    constructor(ctx) {
        super(ctx)
    }

    getConfigWeb = (query) => {
        return this.get('/config/web', query)
    }

    getPageConfig = (page) => {
        return this.get(`/config/pages/${page}`);
    };

    getContact = (query) => {
        return this.get('/config/contact', query)
    }

    getStaticContent = (query) => {
        return this.get("/static-content", query)
    }

    getProvince = (query) => {
        return this.get('/config/province', query)
    }

    getCountry = (query) => {
        return this.get('/config/country', query)
    }

    getDistrict = (query) => {
        return this.get('/config/district', query)
    }

    getWard = (query) => {
        return this.get('/config/ward', query)
    }

    getPaymentConfig = () => {
        return this.get('/config/payment')
    }

    getPolicyServiceConfig = () => {
        return this.get('/config/policy-service')
    }

    postAppConfig = (keys) => {
        return this.post('/config/app-config', { keys });
    }
}
